import React from 'react';
import api from "../utils/api";
import { useAuth } from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Divider, { dividerClasses } from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MuiMenuItem from '@mui/material/MenuItem';
import { paperClasses } from '@mui/material/Paper';
import { listClasses } from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon, { listItemIconClasses } from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';

const MenuItem = styled(MuiMenuItem)({
    margin: '2px 0',
});

export default function OptionsMenu({ user = null, anchorEl = null, open = false, onClose }) {
    const { _logout, _deleteUser } = useAuth();
    const navigate = useNavigate();

    const userName = user?.name || `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || 'User';
    const userEmail = user?.email || '';

    const handleLogout = async () => {
        try {
            await api.delete("/session/destroy");
            _logout();
            _deleteUser();
            navigate("/login")
        } catch (e) {
            console.log(e);
        }
    }

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <Menu
            anchorEl={anchorEl}
            id="user-menu"
            open={open}
            onClose={handleClose}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            sx={{
                [`& .${listClasses.root}`]: {
                    padding: '4px',
                },
                [`& .${paperClasses.root}`]: {
                    padding: 0,
                },
                [`& .${dividerClasses.root}`]: {
                    margin: '4px -4px',
                },
            }}
        >
            {user
                ? [
                      <Box key="user-info" sx={{ px: 2, py: 1.5 }}>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              {userName}
                          </Typography>
                          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                              {userEmail}
                          </Typography>
                      </Box>,
                      <Divider key="user-divider" />,
                  ]
                : null}
            <MenuItem
                onClick={handleClose}
                sx={{
                    [`& .${listItemIconClasses.root}`]: {
                        ml: 'auto',
                        minWidth: 0,
                    },
                }}
            >
                <ListItemText onClick={handleLogout}>Logout</ListItemText>
                <ListItemIcon>
                    <LogoutRoundedIcon fontSize="small" />
                </ListItemIcon>
            </MenuItem>
        </Menu>
    );
}
